<template>
  <div class="__mainbacground">
    <div class="_registerverification align-items-center">
      <div class="">
        <p>
          Thank you for registering. We just send a verification email to <a href="javascript:void(0)"> {{auth.userEmail}} </a>. Please  check your email to activate your account. Once you re-login, please check and complete your company profile in the Settings menu.
          Our admin will verified your account within 24 hours (working days).
        </p>
        <div class="text-center mt-5">
          <p><b>Still Haven’t Got Your Email?</b></p>
          <button type="button" @click="resendEmail"
                  class="_global__button--corporite pl-4 pr-4 mt-2">
            Resend Email
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'signupVerification',
  computed: {
    ...mapGetters({
      auth: 'register/items',
      error: 'register/error',
      isLoading: 'register/isLoading'
    })
  },
  methods: {
    resendEmail () {
      let payload = {
        userEmail: this.auth.userEmail,
        companyName: this.auth.companyName,
        userId: this.auth.userId,
        companyId: this.auth.companyId,
        userFullname: this.auth.userFullname
      }
      this.$store.dispatch('auth/RESEND_EMAIL', payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/signupVerification/index.vue